import type { AiUsageValuePayload } from '@Application/Ai/AiConfiguration/Models/Actions/aiModelsFetched';

// Unlike `AiModelPayload.usages`, this single enum field is a real nullable enum column, serialized
// through the registry's nullable serializer: it always comes back as `{ value, label }`, never a
// bare string.
export type AiModelConnectionTestPayload = {
	readonly succeeded: boolean;
	readonly message: string;
	readonly testedAt: string;
	readonly usage: AiUsageValuePayload;
	/** French labels of the settings this test rejected. Always an array, empty in the nominal case —
	 * never `null`, unlike the persisted `AiModelPayload.lastTestRejectedSettings`. */
	readonly rejectedSettings: string[];
};

// The response carries no model identifier — connection-test responses are hand-built objects, not
// serialized entities — so `modelId` travels beside the payload, next to `accountId`, the same way
// route-scope identifiers already do for other actions in this layer.
export type AiModelConnectionTestedAction = {
	type: 'AI_MODEL_CONNECTION_TESTED';
	payload: AiModelConnectionTestPayload;
	accountId: number;
	modelId: number;
};

export default (
	payload: AiModelConnectionTestPayload,
	accountId: number,
	modelId: number,
): AiModelConnectionTestedAction => ({
	type: 'AI_MODEL_CONNECTION_TESTED',
	payload,
	accountId,
	modelId,
});
